import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Loader from "@/components/Loader";
import { toast } from "sonner";
import { Save, Cookie } from "lucide-react";

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export default function AdminMenus() {
  const [menus, setMenus] = useState(null);

  useEffect(() => {
    api.get("/admin/content").then(({ data }) => setMenus(data.content.menus || {}));
  }, []);

  const save = async () => {
    try { await api.put("/admin/content", { menus }); toast.success("Menus saved!"); }
    catch { toast.error("Save failed"); }
  };

  if (!menus) return <Loader />;

  return (
    <div className="space-y-5 max-w-2xl">
      <h1 className="text-2xl md:text-3xl font-heading font-extrabold">Menu Management</h1>
      <p className="text-sm text-thali-ink/60">Laddoo is served on Tuesday, Thursday and Saturday.</p>
      <div className="space-y-3">
        {[1, 2, 3, 4, 5, 6, 0].map((wd) => {
          const m = menus[wd] || menus[String(wd)] || { display: "" };
          const laddoo = [2, 4, 6].includes(wd);
          return (
            <div key={wd} className="card-thali" data-testid={`menu-day-${wd}`}>
              <div className="flex items-center justify-between mb-2">
                <b className="font-heading">{DAY_NAMES[wd]}</b>
                {laddoo && <span className="text-xs bg-thali-turmeric/40 rounded-full px-2 py-0.5 flex items-center gap-1"><Cookie className="w-3 h-3" /> Laddoo Day</span>}
              </div>
              <input className="input-thali" value={m.display || ""}
                onChange={(e) => setMenus({ ...menus, [wd]: { ...m, display: e.target.value } })} data-testid={`menu-input-${wd}`} />
            </div>
          );
        })}
      </div>
      <button onClick={save} className="btn-3d-green w-full" data-testid="menu-save"><Save className="w-4 h-4" /> Save Menus</button>
    </div>
  );
}
